import React, { useEffect, useMemo, useState } from "react";
import DivisionCmp from "../../components/cards/DivisionCmp";
import {
  Box,
  Card,
  CardContent,
  createTheme,
  Divider,
  FormControl,
  Grid,
  Typography,
} from "@mui/material";
import MaterialTextFieldComponent from "../../components/textField/MaterialTextFieldCmp";
import DatePickerComponents from "../../components/datePicker/DatePickerComponents";
import AutoCompleteSingleSearch from "../../components/autocomplete/AutoCompleteSingleSearch";
import CustomisedButton from "../../components/button/button";
import PriceInfo from "./compnents/priceInfo";
import SelectableCard from "./compnents/SelectableCard ";
import { useMutation, useQuery } from "react-query";
import {
  ICalculateLoanParamsRequest,
  ICalculateLoanParamsResponse,
  IinitializeParams,
  IInitializeRegistrationParamsResponse,
  ILoanBaseModel,
  IloanTemplateDetail,
} from "../../models/loanNew.Model";
import {
  CalculateLoanParams,
  GetFinancialSuppliersByLoanTemplateAndOrganization,
  GetRegistrationDuration,
  InitializeRegistrationParams,
  RegisterLoan,
} from "../../services/loan.service";
import { IResponse } from "../../models/dropdown.model";
import { ApiResultModel } from "../../models/common.model";
import { debounce, max, set } from "lodash";
import PriceFeildComponent from "../../components/priceFeild/priceFeildComponent";
import { CacheProvider, ThemeProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import {
  CustomerInfoProps,
  ICustomerData,
  ILoanData,
  TFacilityInfoProps,
} from "./newFacilitieRequestType";
import FacilityInfoSkeleton from "./FacilityInfoSkeleton";
import { convertToLocalDateTime } from "../../utility/dateUtility";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
export default function NewFacilitieRequest() {
  const [customerData, setCustomerData] = useState<ICustomerData>({
    nationalCode: "",
    birthDate: undefined,
    mobile: "",
  });
  const [loanData, setLoanData] = useState<ILoanData>();
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2500);

    return () => clearTimeout(timer);
  }, []);
  const { mutate: RegisterLoanMutation } = useMutation(RegisterLoan, {
    onSuccess: (data: boolean) => {
      if (data) {
        toast.success(" عملیات با موفقیت انجام شد.");
        history.push("/facilities/FacilitiesInProgress");
      }
    },
  });
  useEffect(() => {
    type AggregatedData = ILoanData & ICustomerData;
    if (loanData) {
      const request: any = {
        ...loanData,
        ...customerData,
        stepSpaceId: loanData.stepSpaceId,
        birthDate: convertToLocalDateTime(Number(customerData.birthDate)!),
      };
      RegisterLoanMutation(request);
    }
  }, [loanData]);
  if (loading) {
    return <FacilityInfoSkeleton />;
  }
  return (
    <div className="devForDevisionCard">
      <div className="mTop10">
        <DivisionCmp
          title="مشخصات متقاضی"
          child={
            <CustomerInfo
              customerData={customerData}
              setCustomerData={setCustomerData}
            />
          }
        />
        <br />
        <DivisionCmp
          title=" مشخصات طرح تسهیلات"
          child={
            <FacilitieInfo
              setLoanData={setLoanData}
              customerData={customerData}
            />
          }
        />
      </div>
    </div>
  );
}

const CustomerInfo: React.FC<CustomerInfoProps> = ({
  customerData,
  setCustomerData,
}) => {
  const handleChange = (field: keyof ICustomerData, value: any) => {
    setCustomerData((prev) => ({ ...prev, [field]: value }));
  };
  return (
    <div
      style={{
        paddingRight: "15px",
        paddingTop: "15px",
        paddingBottom: "15px",
      }}
    >
      <Typography className="mbottom20">
        اطلاعات متقاضی را وارد کنید:
      </Typography>
      <Grid container className="mbottom10">
        <Grid xs={6} sm={3} sx={{ padding: "4px" }}>
          <MaterialTextFieldComponent
            value={customerData.nationalCode}
            placeHolder={"کد ملی "}
            label={"کد ملی "}
            required={true}
            name="nationalCode"
            id="nationalCode"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChange("nationalCode", e.target.value)
            }
          />
        </Grid>
        <Grid xs={6} sm={3} sx={{ padding: "4px" }}>
          <FormControl fullWidth className="shadowDatepicker">
            <DatePickerComponents
              // disable={!!dataVerifyCustomer}
              value={customerData.birthDate}
              label={"تاریخ تولد *"}
              onChange={(newDate: Date) => handleChange("birthDate", newDate)}
              range={false}
              fixMainPosition={true}
            />
          </FormControl>
        </Grid>
        <Grid xs={6} sm={3} sx={{ padding: "4px" }}>
          <MaterialTextFieldComponent
            value={customerData.mobile}
            placeHolder={"شماره همراه"}
            label={"شماره همراه"}
            required={true}
            name="mobile"
            id="mobile"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChange("mobile", e.target.value)
            }
          />
        </Grid>
      </Grid>
    </div>
  );
};
const FacilitieInfo = ({ setLoanData, customerData }: TFacilityInfoProps) => {
  const [selectedId, setSelectedId] = useState<number | null>();
  const [loanAmount, setLoanAmount] = useState<string>();
  const [initializeParams, setInitializeParams] = useState<IinitializeParams[]>(
    []
  );
  const [loanTemplates, setLoanTemplates] = useState<IResponse[]>();
  const [loanTemplateId, setLoanTemplateId] = useState<number>();
  const [organizations, setOrganizations] = useState<IResponse[]>();
  const [organizationId, setorganizationId] = useState<number | null>();
  const [amountHint, setAmountHint] = useState<string | null>(null);
  const [registrationDuration, setRegistrationDuration] = useState<
    IResponse[]
  >();
  const [registrationDurationId, setRegistrationDurationId] = useState<
    number | null
  >();
  const [loanTemplateDetail, setLoanTemplateDetail] = useState<
    IloanTemplateDetail[]
  >();
  const [loanTemplateDetailSelected, setLoanTemplateDetailSelected] = useState<
    IloanTemplateDetail
  >();
  const [calculateLoanParams, setCalculateLoanParams] = useState<
    ICalculateLoanParamsResponse
  >({
    loanAmount: 0,
    feeAmount: 0,
    supplierFeeAmount: 0,
    creditAmount: 0,
    installmentAmount: 0,
  });
  const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [prefixer, rtlPlugin],
  });
  const theme = createTheme({
    direction: "rtl",
  });
  //services
  useQuery<IInitializeRegistrationParamsResponse>(
    "InitializeRegistrationParams",
    InitializeRegistrationParams,
    {
      onSuccess(data: IInitializeRegistrationParamsResponse) {
        let loanTemplateTemprory = [] as IResponse[];
        if (data != null && data.initializeParams != null) {
          data.initializeParams.map((element) => {
            loanTemplateTemprory.push(element.loanTemplate);
          });
        }
        setLoanTemplates(loanTemplateTemprory);
        setInitializeParams(data.initializeParams);
        let temp: IloanTemplateDetail[] = [];
        data.financialSuppliers?.map((element) => {
          temp.push({
            financialSupplierId: element.id,
            financialSupplierTitle: element.title,
            financialSupplier: element.additionalData,
          });
        });
        setLoanTemplateDetail(temp);
      },
    }
  );

  const { mutate: GetRegistrationDurationMutation } = useMutation(
    GetRegistrationDuration,
    {
      onSuccess: (data: IResponse[]) => {
        if (data) {
          setRegistrationDuration(data);
        }
      },
    }
  );
  const { mutate: CalculateLoanParamsMutation } = useMutation(
    CalculateLoanParams,
    {
      onSuccess: (data: ICalculateLoanParamsResponse) => {
        if (data) {
          setCalculateLoanParams(data);
        }
      },
    }
  );
  const {
    mutate: GetFinancialSuppliersByLoanTemplateAndOrganizationMutation,
  } = useMutation(GetFinancialSuppliersByLoanTemplateAndOrganization, {
    onSuccess: (data: IloanTemplateDetail[]) => {
      if (data) {
        setLoanTemplateDetail(data);
      }
    },
  });
  //services

  const handleSelectedLoanTemplate = (e: any) => {
    setLoanTemplateId(e);
    setorganizationId(null);
    setSelectedId(null);
    setLoanAmount("");
    setAmountHint(null);
    setRegistrationDurationId(null);
    handleSetNullPriceInfoComponent();
  };
  const handleSelectedOrganization = (e: any) => {
    setorganizationId(e);
    setSelectedId(null);
    setLoanAmount("");
    setAmountHint(null);
    setRegistrationDurationId(null);
    handleSetNullPriceInfoComponent();
  };
  const handleRegistrationDuration = (e: any) => {
    setRegistrationDurationId(e);
  };
  useEffect(() => {
    if (loanTemplateId) {
      let temp = initializeParams.find(
        (item) => item.loanTemplate.id === loanTemplateId
      );
      setOrganizations(temp?.organizations);

      setLoanTemplateDetail(temp?.loanTemplateDetail);
    }
  }, [loanTemplateId]);
  const debouncedGetDuration = useMemo(
    () =>
      debounce((request: ILoanBaseModel) => {
        GetRegistrationDurationMutation(request);
      }, 500),
    []
  );
  useEffect(() => {
    if (loanTemplateId && organizationId) {
      GetFinancialSuppliersByLoanTemplateAndOrganizationMutation({
        loanTemplateId,
        organizationId,
      });
    }
  }, [organizationId]);
  useEffect(() => {
    if (loanAmount && loanTemplateId && selectedId) {
      let request = {} as ILoanBaseModel;
      request.loanAmount = Number(String(loanAmount).replace(/,/g, ""));
      request.financialSupplierId = Number(selectedId);
      request.loanTemplateId = loanTemplateId!;
      // GetRegistrationDurationMutation(request);
      debouncedGetDuration(request);
    }
  }, [loanAmount]);

  useEffect(() => {
    if (loanAmount && loanTemplateId && selectedId && registrationDurationId) {
      const request = {} as ICalculateLoanParamsRequest;
      request.stepSpaceId = registrationDurationId;
      request.financialSupplierId = Number(selectedId);
      request.loanAmount = Number(String(loanAmount).replace(/,/g, ""));
      request.loanTemplateId = loanTemplateId!;
      request.organizationId = organizationId!;
      CalculateLoanParamsMutation(request);
    }
  }, [
    loanAmount,
    loanTemplateId,
    selectedId,
    organizationId,
    registrationDurationId,
  ]);
  const handleAmountChange = (e: any) => {
    setLoanAmount(e.target.value);
    const numericValue = Number(e.target.value.replace(/,/g, ""));
    setRegistrationDurationId(null);
    handleSetNullPriceInfoComponent();

    if (
      loanTemplateDetailSelected &&
      loanTemplateDetailSelected.maxAmount !== undefined &&
      loanTemplateDetailSelected.minAmount !== undefined &&
      (loanTemplateDetailSelected.maxAmount < numericValue ||
        loanTemplateDetailSelected.minAmount > numericValue)
    ) {
      setAmountHint("مقدار وارد شده در بازه مجاز نمی باشد");
    } else {
      setAmountHint(null);
    }
  };
  const handleRegisterLoanRequest = () => {
    const request = {} as ILoanData;
    if (
      loanTemplateId &&
      // organizationId &&
      selectedId &&
      registrationDurationId
    ) {
      const loanAmountWithoutSeprator = loanAmount!.replace(/,/g, "");
      request.loanTemplateId = loanTemplateId;
      if (organizationId) {
        request.organizationId = organizationId;
      }
      request.financialSupplierId = Number(selectedId);
      request.loanAmount = Number(loanAmountWithoutSeprator);
      request.stepSpaceId = registrationDurationId as number;
      setLoanData(request);
    }
  };
  const handleSetNullPriceInfoComponent = () => {
    setCalculateLoanParams({
      loanAmount: 0,
      feeAmount: 0,
      supplierFeeAmount: 0,
      creditAmount: 0,
      installmentAmount: 0,
    } as ICalculateLoanParamsResponse);
  };
  return (
    <Grid container>
      <Grid
        container
        md={6}
        style={{ padding: "20px" }}
        borderLeft={{ xs: "unset", md: "1.2px solid #CFD8DC" }}
      >
        <Grid xs={12} sx={{ padding: "10px" }}>
          <AutoCompleteSingleSearch
            //   disable={!!dataVerifyCustomer}
            label={"عنوان طرح تسهیلات*"}
            name={`financialSupplierId`}
            id={`financialSupplierId`}
            value={loanTemplateId}
            options={loanTemplates}
            onChange={handleSelectedLoanTemplate}
            //   responseValue={branchStoreValue}
          />
        </Grid>
        {organizations && (
          <Grid xs={12} sx={{ padding: "10px" }}>
            <AutoCompleteSingleSearch
              // disable={!!dataVerifyCustomer}
              label={"سازمان*"}
              name={`organizationId`}
              id={`organizationId`}
              value={organizationId}
              options={organizations}
              onChange={handleSelectedOrganization}
              // responseValue={branchStoreValue}
            />
          </Grid>
        )}
        <Grid xs={12}>
          <Typography className="mbottom10 mTop20">منبع تامین مالی</Typography>
          <Grid
            container
            className="mbottom20"
            sx={{
              opacity: loanTemplateId ? 1 : 0.5,
              pointerEvents: loanTemplateId ? "auto" : "none",
            }}
          >
            {loanTemplateDetail?.map((card) => (
              <SelectableCard
                key={card.financialSupplierId}
                image={card.financialSupplier!}
                text={card.financialSupplierTitle}
                selected={card.financialSupplierId === selectedId}
                onClick={() => {
                  setSelectedId(card.financialSupplierId);
                  const loanTemplateDetailTemp = loanTemplateDetail?.find(
                    (item) =>
                      item.financialSupplierId ===
                      Number(card.financialSupplierId)
                  );
                  setLoanTemplateDetailSelected(loanTemplateDetailTemp!);
                  setLoanAmount("");
                  setAmountHint(null);
                  setRegistrationDurationId(null);
                  handleSetNullPriceInfoComponent();
                }}
              />
            ))}
          </Grid>
        </Grid>
        {selectedId &&
          loanTemplateDetailSelected?.minAmount &&
          loanTemplateDetailSelected?.maxAmount && (
            <Grid
              xs={12}
              className="mbottom10"
              sx={{ padding: "5px", color: "#FB8C00" }}
            >
              <Typography>
                میزان تسهیلات قابل اعطا حداقل{" "}
                {loanTemplateDetailSelected.minAmount.toLocaleString()} ریال و
                حداکثر .{loanTemplateDetailSelected.maxAmount.toLocaleString()}{" "}
                ریال میباشد
              </Typography>
            </Grid>
          )}
        <Grid
          xs={12}
          sx={{
            padding: "10px",
            opacity: selectedId ? 1 : 0.5,
            pointerEvents: selectedId ? "auto" : "none",
          }}
        >
          <CacheProvider value={cacheRtl}>
            <ThemeProvider theme={theme}>
              <PriceFeildComponent
                showPersianWords={false}
                value={loanAmount}
                placeHolder={"مبلغ تسهیلات (ريال)"}
                label={"مبلغ تسهیلات (ريال)"}
                required={true}
                name="loanAmount"
                id="loanAmount"
                onChange={handleAmountChange}
                error={amountHint !== null}
              />
            </ThemeProvider>
          </CacheProvider>
        </Grid>
        {amountHint && (
          <Grid
            xs={12}
            sx={{ padding: "5px", color: "red", fontSize: "11px !important" }}
          >
            <div>{amountHint}</div>
          </Grid>
        )}
        <Grid
          xs={12}
          sx={{
            padding: "10px",
            opacity: loanAmount ? 1 : 0.5,
            pointerEvents: loanAmount ? "auto" : "none",
          }}
        >
          <AutoCompleteSingleSearch
            // disable={!!dataVerifyCustomer}
            label={"مدت بازپرداخت*"}
            name={`registrationDurationId`}
            id={`registrationDurationId`}
            value={registrationDurationId}
            options={registrationDuration}
            onChange={handleRegistrationDuration}
            // responseValue={branchStoreValue}
          />
        </Grid>
      </Grid>
      <Grid container md={6} style={{ padding: "20px" }}>
        {" "}
        <Grid xs={12}>
          <PriceInfo {...calculateLoanParams} />
        </Grid>
      </Grid>
      <Grid
        container
        md={12}
        style={{ paddingLeft: "20px", justifyContent: "end" }}
      >
        <CustomisedButton
          title={` ثبت درخواست تسهیلات `}
          disable={
            !loanTemplateId ||
            !selectedId ||
            !loanAmount ||
            !registrationDurationId ||
            !customerData.birthDate ||
            !customerData.nationalCode ||
            !customerData.mobile
          }
          onClick={handleRegisterLoanRequest}
          type="submit"
        />
      </Grid>
    </Grid>
  );
};
